import { useTranslation } from 'react-i18next'
import { AddRole } from '~/features/Roles/AddRole'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'roles', link: '/settings/roles' },
  { titleI18n: 'roles' },
]

export const AddRolePage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('create role')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create role')}</PageTitle>
      </Container>
      <AddRole />
    </PageContainer>
  )
}
